import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface DialogContent {
  title: string;
  contentHtml: string;
}

export interface ButtonDescriptor {
  title: string;
  action: string;
}

@Component({
  imports: [MatDialogModule, NgIf, MatButtonModule, NgForOf, NgClass],
  template: `
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-dialog-content>
      <p *ngIf="content">{{ content }}</p>
      <div *ngIf="contentHtml" [innerHtml]="contentHtml"></div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button
        mat-raised-button
        color="primary"
        *ngFor="let button of buttons; let isLast = last"
        (click)="dialogRef.close(button.action)"
        [ngClass]="{ 'add-button': isLast }"
      >
        {{ button.title }}
      </button>
    </mat-dialog-actions>
  `,
})
export class VDialogComponent {
  @Input() isSuccess = true;
  @Input() showIcon = true;
  @Input() title: string;
  @Input() content: string;
  @Input() contentHtml: string;
  @Input() buttons: Array<ButtonDescriptor>;

  constructor(public dialogRef: MatDialogRef<VDialogComponent>) {}
}
